import React from "react";
import { Container, Form } from "react-bootstrap";
import TopHeader from "../Common/TopHeader";
import { useAppSelector } from "../../core/redux/hooks";
import constant from "../../core/constant";

const Settings = () => {
    let settingsState = useAppSelector((state) => state.settings);
    const [link, setLink] = React.useState<any>();
    const [showLoader, setShowLoader] = React.useState(true);

    React.useEffect(() => {
        setShowLoader(false);
        console.log(settingsState, 'settingsState =======================>');
        if (settingsState.links) {
            let linksArray = JSON.parse(settingsState.links);
            setLink([...linksArray]);
        }
    }, [settingsState]);

    return (
        <>

            <Container fluid>
                <TopHeader
                    heading="Settings"
                    to={constant.SETTING_EDIT}
                    action="Edit"
                    className=""
                    id="settings-edit"
                />
                <div className="mt-4">
                    {
                        !showLoader &&
                        <Form>
                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <label>
                                        Name
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <span> {settingsState.name}</span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <label>
                                        SSM Base URL
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <span> {settingsState.ssm_api_base_url ? settingsState.ssm_api_base_url : "-"}</span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <label>
                                        Logo
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <img
                                        alt=""
                                        src={settingsState.logo}
                                        height="auto"
                                        className="d-inline-block align-top"
                                        style={{ maxWidth: 200 }}
                                    />
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <label>
                                        Call Timeout (Seconds)
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <span> {settingsState.call_timeout ? settingsState.call_timeout : "-"}</span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <label>
                                        Kiosk Motion Notification Video Timeout (Minutes)
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <span> {settingsState.notification_timeout ? settingsState.notification_timeout : "-"}</span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <label>
                                        Call Queue
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    {/* Read-only toggle: reflects the saved value; not editable in view mode */}
                                    <div className="form-check form-switch cus-toggle ms-2 mb-2">
                                        <input
                                            type="checkbox"
                                            role="switch"
                                            className="form-check-input"
                                            checked={!!settingsState.enableCallQueue}
                                            disabled
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>

                            {settingsState.enableCallQueue && (
                                <>
                                    <div className="row mb-2">
                                        <div className="col-md-4">
                                            <label>
                                                Call Queue Prompt Message
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <span> {settingsState.callQueuePromptMessage ? settingsState.callQueuePromptMessage : "-"}</span>
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-md-4">
                                            <label>
                                                Call Queue Prompt Interval (Seconds)
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <span> {settingsState.callQueuePromptInterval ? settingsState.callQueuePromptInterval : "90"}</span>
                                        </div>
                                    </div>
                                </>
                            )}
                            {/* <fieldset className="border col-md-8 mt-2 mb-4" style={{ borderRadius: '5px' }}>
                                <legend className="float-none w-auto m-0">PMS Integration Information</legend>
                                <div className="row mb-2">
                                    <div className="col-md-6">
                                        <label>PMS</label>
                                    </div>
                                    <div className="col-md-6">
                                        <span> {(settingsState.hummingBirdOrSSM && settingsState.hummingBirdOrSSM !== undefined) && (settingsState.hummingBirdOrSSM === "true") ? "SSM" : "HummingBird"}</span>
                                    </div>
                                </div>
                                {
                                    settingsState.hummingBirdOrSSM === "true" ?
                                        <>
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <label>SSM USER ID</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <span> {(settingsState.ssm_user_id && settingsState.ssm_user_id !== 'undefined') ? settingsState.ssm_user_id : "-"}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <label>SSM PASSWORD</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <span> {(settingsState.ssm_password && settingsState.ssm_password !== 'undefined') ? settingsState.ssm_password : "-"}</span>
                                                </div>
                                            </div>

                                        </> :
                                        <>
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <label>RCM Application ID</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <span> {(settingsState.application_id && settingsState.application_id !== 'undefined') ? settingsState.application_id : "-"}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <label>Customer PMS Company ID</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <span> {(settingsState.company_id && settingsState.company_id !== 'undefined') ? settingsState.company_id : "-"}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <label>RCM API Key</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <span> {(settingsState.storageapi_key && settingsState.storageapi_key !== 'undefined') ? settingsState.storageapi_key : "-"}</span>
                                                </div>
                                            </div>
                                        </>
                                }

                            </fieldset> */}

                            <div className="row mb-2">
                                <div className="mt-2 col-md-4">
                                    <label>
                                        Caller Tune
                                    </label>
                                </div>
                                <div className="mt-2 col-md-4">
                                    <audio src={settingsState?.callerTune} controls preload={settingsState?.callerTune}>
                                        <source src={settingsState?.callerTune} type="audio/mp3" />
                                    </audio>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="mt-2 col-md-4">
                                    <label>
                                        Notification Ringtone
                                    </label>
                                </div>
                                <div className="mt-2 col-md-4">
                                    <audio src={settingsState?.ringTone} controls preload={settingsState?.ringTone}>
                                        <source src={settingsState?.ringTone} type="audio/mp3" />
                                    </audio>
                                </div>
                            </div>

                            {
                                (link === "" || link === null || link === undefined || Object.keys(link).length <= 0) ? ""
                                    : <div className="row mb-2">
                                        <div className="col-md-4">
                                            <label>
                                                Links
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            {link
                                                ? link.map((item: any, i: any) => {
                                                    return (
                                                        <li key={i}>
                                                            <a
                                                                href={Object.values(
                                                                    item
                                                                ).toString()}
                                                                target="_blank"
                                                                className="app-link-color"
                                                            >
                                                                {Object.keys(item)}
                                                            </a>
                                                        </li>
                                                    );
                                                })
                                                : ""}
                                        </div>
                                    </div>
                            }


                        </Form>
                    }

                </div>
            </Container>
        </>
    );
};

export default Settings;
